<script lang="ts">
	export let fill = "#6591fa";

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 24 24">
	<g>
		<g transform="translate(0 19.2)">
			<circle cx="2.4" cy="2.4" r="2.4" fill={fill} />
		</g>
		<g transform="translate(4.799 10.8)">
			<circle cx="2.4" cy="2.4" r="2.4" fill={fill} />
		</g>
		<g transform="translate(14.399 14.4)">
			<circle cx="2.4" cy="2.4" r="2.4" fill={fill} />
		</g>
		<g transform="translate(19.199)">
			<circle cx="2.4" cy="2.4" r="2.4" fill={fill} />
		</g>
		<g>
			<path
				d="M48.969 234.384a.485.485 0 0 1-.423-.719l4.822-8.686a.483.483 0 0 1 .612-.211l9.32 3.952 4.43-14.31a.484.484 0 0 1 .925.287l-4.588 14.821a.484.484 0 0 1-.652.3L54 225.83l-4.61 8.3a.484.484 0 0 1-.421.254z"
				transform="translate(-46.57 -212.3)"
				fill={fill} />
		</g>
	</g>
</svg>

<style lang="scss">
</style>
